// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'

import bg from '@/components/component/background.vue';
import waitBar from '@/components/component/wait-bar.vue';
import button from '@/components/component/button.vue';
Vue.component('bg-popup', bg);
Vue.component('wait-bar', waitBar);
Vue.component('ct-button', button);

import axios from 'axios'
Vue.$http = axios;

import 'vue-awesome/icons';
import Icon from 'vue-awesome/components/Icon';
Vue.component('icon', Icon)

Vue.config.productionTip = false

import VueCookie from 'vue-cookie';
Vue.use(VueCookie);

import VueI18n from 'vue-i18n';
const data = require('./message.json');
Vue.use(VueI18n);
const i18n = new VueI18n({
	locale: "ja",
	messages: data
});

import '@/js/common.js'
import '@/js/dateTime.js'
import '@/js/string.js'

router.beforeEach((to, from, next) => {
	let loggedIn = ((store.getters.admin.account != "") && (store.getters.admin.account != undefined)) ? true : false;
	if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
		next({ path: '/admin'});
	} else {
		next();
	}
});

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	i18n,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js